import * as React from 'react';
import { useA11yCheck } from '../lib/use-a11y-check';
import { useA11yResult } from '../lib/use-a11y-result';
import { CodePreviewFrame } from './code-preview-frame';
export const CodePreviewShowroomFrame = (props) => {
    const rootRef = React.useRef(null);
    const { setResult } = useA11yResult();
    useA11yCheck(rootRef, setResult);
    return React.createElement(CodePreviewFrame, Object.assign({}, props, { ref: rootRef }));
};
//# sourceMappingURL=code-preview-showroom-frame.js.map